import { useEffect } from 'react';

// Keeps the screen from dimming/locking on its own while `enabled` (in a
// voice room) - on a phone a locked screen means the browser suspends the
// page and the mic with it. Screen Wake Lock API: Chrome/Electron, Android
// Chrome, iOS Safari 16.4+. Unsupported browsers just don't get it.
//
// The browser drops the lock whenever the page is hidden (tab switch, app
// in background), so it's re-requested each time the page becomes visible
// again for as long as `enabled` holds.
export function useWakeLock(enabled) {
  useEffect(() => {
    if (!enabled || !('wakeLock' in navigator)) return undefined;
    let sentinel = null;
    let cancelled = false;

    const acquire = () => {
      if (document.visibilityState !== 'visible' || (sentinel && !sentinel.released)) return;
      navigator.wakeLock.request('screen')
        .then((s) => {
          if (cancelled) s.release().catch(() => {});
          else sentinel = s;
        })
        // Refused (low battery mode, permissions policy) - not worth surfacing.
        .catch(() => {});
    };

    acquire();
    document.addEventListener('visibilitychange', acquire);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', acquire);
      if (sentinel) sentinel.release().catch(() => {});
    };
  }, [enabled]);
}
